import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import moment from 'moment';
import PromoMessage from '../../promo-message';
import DatePicker from '../../date-picker';

class Component extends BaseComponent {
    render({ route }) {
        if (route != 'everyone') {
            return this.renderForYou();
        }

        return this.renderForEveryone();
    }

    renderForYou = () => {
        if (this.props.logged_in && this.props.hexagram && this.props.hexagram.you) {
            return (
                <daily-hexagram-mobile>
                    {this.renderTop()}
                    {this.renderHexagram(this.props.hexagram.you)}
                </daily-hexagram-mobile>
            );
        }

        return (
            <daily-hexagram-mobile>
                {this.renderTop()}
                <img
                    src='https://gfx.tarot.com/images/daily-pages/daily-icons/hexagram.svg'
                    alt='Unknown Hexagram'
                />
                <h2>Create Your Profile To Find Out!</h2>
                <p>
                    Looking for your Hexagram of the Day? Create your profile to receive a Hexagram that's
                    personalized to YOU every day!
                </p>
                <a href='#login' className='button'>CREATE MY PROFILE</a>
                <p className='signup_promo_text'>
                    Already a Tarot.com member? <a href='#login'>Login Now</a>
                </p>
            </daily-hexagram-mobile>
        );
    }

    renderForEveryone = () => {
        if (this.props.hexagram && this.props.hexagram.everyone) {
            return (
                <daily-hexagram-mobile>
                    {this.renderTop()}
                    {this.renderHexagram(this.props.hexagram.everyone)}
                </daily-hexagram-mobile>
            );
        }

        return (<daily-hexagram-mobile />);
    }

    renderTop = () => {
        return [
            <row className='is-aligned-center'>
                <column className='is-1'>
                    <DatePicker
                        url={`${this.props.base_url || '/daily-hexagram'}/:date`}
                        page='hexagram'
                        autosubmit='true'
                    />
                </column>
                <column className='is-11 has-padding-20-left-mobile'>
                    {this.renderDailyLinks()}
                </column>
            </row>,
            <h1>Hexagram of the Day</h1>,
        ];
    }

    renderHexagram = (hexagram) => {
        if (hexagram) {
            const placement = this.props.base_url.match(/vip/) ? 'in-product' : 'text';
            const tags = this.props.base_url.match(/vip/) ? 'vip,text,daily' : 'hexagram';

            return [
                <a href={`/i-ching/hexagrams/${hexagram.title.toLowerCase().replace(/\s+/g, '-')}`}>
                    #{hexagram.id}: {hexagram.title}
                </a>,
                <a href={`/i-ching/hexagrams/${hexagram.title.toLowerCase().replace(/\s+/g, '-')}`}>
                    <img
                        src={`https://gfx.tarot.com/images/iching/iching-general/${hexagram.id}.jpg`}
                        alt={hexagram.title}
                    />
                </a>,
                <p dangerouslySetInnerHTML={{__html: `
                    <b>${moment(hexagram.date).format('M.D.YY')}:</b>
                    ${hexagram.main_text}
                `}} />,
                <p><PromoMessage placement={placement} tags={tags} /></p>,
            ];
        }

        return null;
    }

    renderDailyLinks = () => {
        return (
            <div className='daily-links'>
                <a
                    href='#everyone'
                    className={this.props.route == 'everyone' ? 'selected' : ''}
                >
                    FOR EVERYONE
                </a>
                <a
                    href='#you'
                    className={this.props.route != 'everyone' ? 'selected' : ''}
                >
                    FOR YOU
                </a>
                <a href='/readings-reports/subscription/vip-membership'>VIP Horoscopes</a>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    hexagram: state.hexagram,
    logged_in: state.user && state.user.logged_in,
    route: state.route,
});

export default connect(mapStateToProps)(Component);